import { motion } from 'framer-motion'
import { useLanguage } from '../contexts/LanguageContext.jsx'
import { Dumbbell, Heart, Users, Shield, Clock, Trophy } from 'lucide-react'

function Features() {
  const { language, t } = useLanguage()

  const features = [
    {
      icon: Dumbbell,
      title: language === 'ar' ? 'أحدث المعدات' : 'Modern Equipment',
      description: language === 'ar' 
        ? 'نقدم أحدث المعدات الرياضية العالمية لضمان أفضل أداء'
        : 'We offer the latest global sports equipment to ensure the best performance',
    },
    {
      icon: Users,
      title: language === 'ar' ? 'مدربون محترفون' : 'Professional Trainers',
      description: language === 'ar'
        ? 'فريق من المدربين المعتمدين دولياً لمساعدتك في رحلتك'
        : 'A team of internationally certified trainers to help you on your journey',
    },
    {
      icon: Clock,
      title: '24/7',
      description: language === 'ar'
        ? 'مفتوح على مدار الساعة طوال أيام الأسبوع'
        : 'Open 24 hours a day, 7 days a week',
    },
    {
      icon: Heart,
      title: language === 'ar' ? 'برامج متنوعة' : 'Diverse Programs',
      description: language === 'ar'
        ? 'برامج تدريبية متنوعة تناسب جميع المستويات والأهداف'
        : 'Various training programs suitable for all levels and goals',
    },
    {
      icon: Shield,
      title: language === 'ar' ? 'نظافة وتعقيم' : 'Cleanliness & Sanitization',
      description: language === 'ar'
        ? 'معايير صحية عالية ونظافة مستمرة في جميع المناطق'
        : 'High health standards and continuous cleanliness in all areas',
    },
    {
      icon: Trophy,
      title: language === 'ar' ? 'نتائج مضمونة' : 'Guaranteed Results',
      description: language === 'ar'
        ? 'ضمان تحقيق أهدافك مع متابعة مستمرة لتطورك'
        : 'Guarantee of achieving your goals with continuous follow-up of your progress',
    },
  ]

  return (
    <section id="features" className="py-24 bg-darker relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,215,0,0.05),transparent_50%)]" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block px-4 py-2 rounded-full bg-yellow-400/10 text-yellow-400 text-sm font-medium mb-4">
            {language === 'ar' ? 'لماذا نحن' : 'Why Us'}
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
            {language === 'ar' ? 'مميزات ' : 'Features of '}
            <span className="text-gradient">{language === 'ar' ? 'نادي أوكسجين' : 'Oxygen Gym'}</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            {language === 'ar' 
              ? 'نقدم لك تجربة رياضية فريدة تجمع بين الاحترافية والراحة'
              : 'We offer you a unique sports experience that combines professionalism and comfort'}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="group p-8 rounded-2xl bg-gray-900/50 border border-white/5 hover:border-yellow-400/30 transition-all duration-300 hover-lift"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-yellow-400/20 to-orange-500/20 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <feature.icon className="w-7 h-7 text-yellow-400" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Features
